import { useEffect, useState } from "react";
import { useAuthenticatedApiClient } from "@/hooks/useAuthenticatedApiClient";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";
import { ShareApplicationPerson } from "@/types/ShareApplication";

export interface UseShareApplicationWorkflowReturn {
  people: ShareApplicationPerson[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useShareApplicationWorkflow = (
  financialApplicationId?: string
): UseShareApplicationWorkflowReturn => {
  const [people, setPeople] = useState<ShareApplicationPerson[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const fetchShareApplicationPeople = async () => {
    if (!financialApplicationId) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      const response =
        await financialApplicationApiClient.getShareApplicationPeople(financialApplicationId);
      setPeople(response.people);
    } catch (err) {
      console.error("Failed to fetch share application people:", err);
      setError("Failed to load people data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchShareApplicationPeople();
  }, [financialApplicationId]);

  return {
    people,
    isLoading,
    error,
    refetch: fetchShareApplicationPeople,
  };
};
